import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { useTranslation } from 'react-i18next';
import styles from '../sass/components/MessageSentModal.module.scss';
import Button from './Button';
import ModalCloseButton from './ModalCloseButton';
import { useTenant } from './TenantContext';
import { presetBrand } from '../util/presetBrand';

interface MessageSentModalProps {
  onClose: () => void;
}

export default function MessageSentModal({ onClose }: MessageSentModalProps) {
  const { t } = useTranslation();
  // A preset tenant (Aperio) signs with its own name; everyone else, Go Oil
  // included, reads exactly what they did.
  const brandName = presetBrand(useTenant()?.themePreset)?.name ?? 'Go Oil';
  return (
    <div className={styles.modal}>
      <ModalCloseButton onClose={onClose} />
      <div className={styles.header}>
        <Button
          variant="tertiary"
          onClick={onClose}
        >
          <ChevronLeft />
          {t('assistance.backToBooking')}
        </Button>
      </div>
      <div className={styles.body}>
        <h4>{t('assistance.sent.title')}</h4>
        <p>{t('assistance.sent.body', { brand: brandName })}</p>
        <Button className={styles.button} onClick={onClose}>
          {t('assistance.backToBooking')}
        </Button>
      </div>
    </div>
  );
}
